import React from "react";

import classes from "./TopToolBar.module.css";
import TiwtIcon from "../../../assets/svg/Icon awesome-twitter.svg";
import FaceIcon from "../../../assets/svg/Icon awesome-facebook-f.svg";
import Instagram from "../../../assets/svg/Instagram.svg";
// import downArrow from "../../../assets/svg/smallWhiteDownArrow.svg";
import flagImg from "../../../assets/Img/Flag/MalysiaFlag.png";

const TopToolBar = (props)=>(
    <div className={classes.TopToolBar}>
        <div className={classes.Icons}>
        <img src={FaceIcon} alt="FaceIcon"/>
        <img src={TiwtIcon} alt="TiwtIcon" />
        <img src={Instagram} alt="Instagram" />
        </div>
        <div className={classes.TopNavigationItem}>
            <a href='/#footer' >Our Services</a>
            <a href='/#footer'  >Contact Us</a>
            <a href='/#footer' >Help</a>
            <a href='/#' >MYR</a>{/*<img className={classes.DownArrow} src={downArrow}  alt="" style={{margin:'0 0 2% 4%'}}/>*/}
            <a href='/#' >En </a> {/*<img className={classes.DownArrow} src={downArrow}  alt="" style={{margin:'0 0 2% 4%'}}/>*/}
            <a href='/#' ><img src={flagImg} alt=''/></a>
        </div>
    </div>
);

export default TopToolBar;
